/* eslint-disable */
import {useLocation, useNavigate} from 'react-router-dom'
import React, {useEffect} from 'react'
import {ProductCard} from './components/ProductCard'
import BgGradient from '../../../static/images/bggradient.webp'
import FeedbackSection from '../components/feedback'
import KinderGarden from '../../../static/images/kindergarden.webp'
import ams from '../../../static/images/ams.webp'
import GreenCountry from '../../../static/images/green-country.webp'
import { useTranslation } from 'react-i18next'


// eslint-disable-next-line import/prefer-default-export
export const Product = React.memo(() => {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()

    useEffect(() => {
        // Apply smooth scroll behavior to the document
        document.documentElement.style.scrollBehavior = 'smooth'

        // Smooth scroll to the top when the route changes
        window.scrollTo({top: 0, behavior: 'smooth'})
    }, [location]) // Triggered when location (route) changes

    const usData = [
        {
            index: '4',
            universalImg: KinderGarden,
            title: t('landing.cards.kindergarden.title'),
            text: t('landing.cards.kindergarden.text'),
            text2: t('landing.cards.kindergarden.text2'),
            text3: t('landing.cards.kindergarden.text3'),
            off: true,
            android: 'https://play.google.com/store/apps/details?id=uz.realsoft.ai.onesystemmoblie&pcampaignid=web_share',
            ios: 'https://apps.apple.com/uz/app/maktabgacha-talim/id6739493059'
        },
        {
            index: '5',
            universalImg: 'https://s3.realsoft.ai/frontassets/gifvideo.gif',
            title: t('landing.cards.school.title'),
            text: t('landing.cards.school.text'),
            off: true,
        },
        {
            index: '6',
            universalImg: 'https://s3.realsoft.ai/frontassets/green-pixel.webp',
            title: t('landing.cards.green.title'),
            text: t('landing.cards.green.text'),
            off: true,
        },
        {
            index: '7',
            universalImg: 'https://s3.realsoft.ai/frontassets/bazar-control.webp',
            title: t('landing.cards.bazar.title'),
            text: t('landing.cards.bazar.text'),
            off: true,
        },
        {
            index: '8',
            universalImg: ams,
            title: t('landing.cards.ams.title'),
            text: t('landing.cards.ams.title'),
            off: true,
            android: 'https://play.google.com/store/apps/details?id=uz.ams.mobile&pcampaignid=web_share',
            ios: 'https://apps.apple.com/uz/app/ams-lite/id6744095378',
        },
        {
            index: '9',
            video: 'https://s3.realsoft.ai/frontassets/greencountry.mp4',
            universalImg: GreenCountry,
            title: t('landing.cards.green-country.title'),
            text: t('landing.cards.green-country.text'),
            text2: t('landing.cards.green-country.text2'),
            text3: t('landing.cards.green-country.text3'),
            off: true,
            android: 'https://play.google.com/store/apps/details?id=tj.greentajikistan.mobile&pcampaignid=web_share',
        }
    ]

    return (
        <>
            <div className="w-full flex  flex-col px-[24px] lg:max-w-[1440px] lg:m-auto lg:px-[20px] gap-[100px]">
                <section
                    style={{
                        backgroundImage: `url(${BgGradient})`,
                    }}
                >
                    <div className="flex flex-col pt-[38px] items-center gap-[15px]">
                        <span className="text-[28px] text-center font-[300]
                        text-[#262626] dark:text-white"
                        >
                            {t('landing.products.mainTitle')}
                        </span>
                        <div className="flex items-center">
                            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,
                            jsx-a11y/click-events-have-key-events */}
                            <span
                                onClick={() => navigate('/')}
                                className="text-[14px] cursor-pointer font-[300] dark:text-white text-[#262626]"
                            >
                                {t('landing.products.breadcrumb.home')}
                            </span>
                            <span className="text-[14px] cursor-pointer
                            font-normal dark:text-white text-[#262626]"
                            >
                                /{t('landing.products.breadcrumb.current')}
                            </span>
                        </div>
                        <div className="w-[100%] relative overflow-hidden
                        sm:h-[179px] md:h-[250px] lg:h-[630px] lg:px-[40px]"
                        >
                            <video
                                src="https://s3.realsoft.ai/frontassets/products.webm"
                                className="w-full h-full object-cover"
                                autoPlay
                                muted
                                loop
                                playsInline
                            />
                        </div>
                    </div>
                </section>
                <section>
                    <div className="flex w-[100%] lg:mb-[110px] md:mb-[57px]
                    lg:px-[24px] flex-col items-center sm:gap-[22px] md:gap-[100px] lg:gap-[120px]"
                    >
                        {usData.map((item) => (
                            <ProductCard
                             key={item.index}
                             video={item.video}
                             text2={item.text2}
                             text3={item.text3}
                             off={item.off}
                             index={item.index}
                             title={item.title}
                             text={item.text}
                             universalImg={item.universalImg}
                             android={item.android}
                             ios={item.ios}
                            />
                        ))}
                    </div>
                </section>
            </div>
            <div className="w-[100%] mt-[20px]">
                <FeedbackSection/>
            </div>

        </>
    )
})
